// import { motion, useScroll, useTransform } from "framer-motion";
// import grid_img_1 from "../../../Assets/Images/grid_img_1.jpg";
// import grid_img_2 from "../../../Assets/Images/grid_img_2.jpg";
// import grid_img_3 from "../../../Assets/Images/grid_img_3.jpg";
// import grid_img_4 from "../../../Assets/Images/grid_img_4.jpg";
// import { useRef } from "react";

// const EventsSection = () => {
//   const sectionRef = useRef(null);
//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["0 1", "1.5 1"],
//   });

//   const middleBoxX = useTransform(scrollYProgress, [0, 1], [0, -200]);
//   const sideBoxY = useTransform(scrollYProgress, [0, 1], [0, -150]);

//   return (
//     <section
//       ref={sectionRef}
//       className="relative flex flex-col lg:flex-row items-center justify-between bg-[#1a180e] text-white overflow-hidden py-12 px-6 lg:px-20 gap-10"
//     >
//       {/* Animated Boxes */}
//       <motion.div
//         style={{ y: sideBoxY }}
//         className="absolute top-0 left-0 w-64 h-64 flex items-center justify-center"
//       >
//         <div className="w-full h-full border-2 border-primaryColor rotate-45 opacity-70 overflow-hidden"></div>
//       </motion.div>

//       <motion.div
//         style={{ x: middleBoxX }}
//         className="absolute right-[35%] bottom-20 w-96 h-96 flex items-center justify-center "
//       >
//         <div className="w-full h-full border-2 border-secondaryColor rotate-45 opacity-70 "></div>
//       </motion.div>

//       <motion.div
//         style={{ y: sideBoxY }}
//         className="absolute bottom-0 right-0 w-64 h-64 flex items-center justify-center"
//       >
//         <div className="w-full h-full border-2 border-primaryColor rotate-45 opacity-70"></div>
//       </motion.div>

//       {/* Left Content */}
//       <div className="relative space-y-10">
//         <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold leading-tight">
//           Take the Next Step <br className="hidden lg:block" /> Toward Your
//           Creative <br className="hidden lg:block" /> and Professional Dreams
//         </h1>
//         <p className="text-white xl:text-lg leading-relaxed xl:w-[550px]">
//           At{" "}
//           <span className="font-semibold text-primaryColor">
//             INSD – International School of Design
//           </span>
//           , we inspire students to transform imagination into innovation. From
//           fashion to interior design, our collaborative courses, design
//           exhibitions, and workshops help you grow into a confident,
//           industry-ready creative professional.
//         </p>

//         <button className="relative bg-gradient-to-r from-primaryColor to-secondaryColor text-white font-bold rounded-xl py-4 px-5 xl:px-8 tracking-wider overflow-hidden group transition-all duration-300 hover:scale-105 shadow-primaryColor">
//           <span className="absolute inset-0 bg-gradient-to-r bg-primaryColor opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out"></span>

//           <span className="relative block transition-transform duration-500 ease-in-out group-hover:-translate-y-10">
//             Explore Courses
//           </span>
//           <span className="absolute inset-0 flex items-center justify-center translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out font-bold text-black">
//             Explore Courses
//           </span>
//         </button>
//       </div>

//       {/* Right Images Grid */}
//       <div className="flex justify-center">
//         <div className="grid grid-cols-2 gap-6">
//           <img
//             src={grid_img_1}
//             alt="INSD fashion workshop"
//             className="rounded-lg object-cover"
//           />
//           <img
//             src={grid_img_3}
//             alt="INSD interior design class"
//             className="rounded-lg object-cover"
//           />
//           <img
//             src={grid_img_2}
//             alt="INSD student exhibition"
//             className="rounded-lg object-cover"
//           />
//           <img
//             src={grid_img_4}
//             alt="INSD creative project"
//             className="rounded-lg object-cover"
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default EventsSection;

import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import grid_img_1 from "../../../Assets/Images/grid_img_1.jpg";
import grid_img_2 from "../../../Assets/Images/grid_img_2.jpg";
import grid_img_3 from "../../../Assets/Images/grid_img_3.jpg";
import grid_img_4 from "../../../Assets/Images/grid_img_4.jpg";

const EventsSection = () => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["0 1", "1.5 1"],
  });

  const middleBoxX = useTransform(scrollYProgress, [0, 1], [0, -200]);
  const sideBoxY = useTransform(scrollYProgress, [0, 1], [0, -150]);
  const imageScale = useTransform(scrollYProgress, [0, 1], [0.9, 1]);
  const textY = useTransform(scrollYProgress, [0, 1], [50, 0]);
  const textOpacity = useTransform(scrollYProgress, [0, 0.5], [0, 1]);

  return (
    <section
      ref={sectionRef}
      className="relative flex flex-col lg:flex-row items-center justify-between bg-gradient-to-br from-[#144982] via-[#1b0a0a] to-[#DA3335] text-white overflow-hidden py-16 md:py-10 lg:py-12 xl:py-18 px-6 md:px-10 lg:px-20 gap-12 lg:gap-16"
    >
      {/* Enhanced Animated Geometric Elements */}
      <motion.div
        style={{ y: sideBoxY }}
        className="absolute -top-20 -left-20 w-80 h-80 flex items-center justify-center opacity-40"
      >
        <div className="w-full h-full border-4 border-primaryColor rotate-45 rounded-3xl shadow-[0_0_50px_rgba(218,51,53,0.3)]"></div>
      </motion.div>

      <motion.div
        style={{ x: middleBoxX }}
        className="absolute right-[35%] bottom-20 w-96 h-96 flex items-center justify-center opacity-30"
      >
        <div className="w-full h-full border-4 border-secondaryColor rotate-45 rounded-3xl shadow-[0_0_50px_rgba(20,73,130,0.3)]"></div>
      </motion.div>

      <motion.div
        style={{ y: sideBoxY }}
        className="absolute -bottom-20 -right-20 w-80 h-80 flex items-center justify-center opacity-40"
      >
        <div className="w-full h-full border-4 border-primaryColor rotate-45 rounded-3xl shadow-[0_0_50px_rgba(218,51,53,0.3)]"></div>
      </motion.div>

      {/* Floating Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <motion.div
          animate={{ y: [0, -20, 0], opacity: [0.3, 0.6, 0.3] }}
          transition={{ duration: 4, repeat: Infinity }}
          className="absolute top-1/4 left-1/4 w-2 h-2 bg-primaryColor rounded-full blur-sm"
        />
        <motion.div
          animate={{ y: [0, 20, 0], opacity: [0.3, 0.6, 0.3] }}
          transition={{ duration: 5, repeat: Infinity, delay: 1 }}
          className="absolute top-2/3 right-1/3 w-2 h-2 bg-secondaryColor rounded-full blur-sm"
        />
        <motion.div
          animate={{ y: [0, -15, 0], opacity: [0.3, 0.6, 0.3] }}
          transition={{ duration: 6, repeat: Infinity, delay: 2 }}
          className="absolute bottom-1/4 right-1/4 w-2 h-2 bg-primaryColor rounded-full blur-sm"
        />
      </div>

      {/* Left Content */}
      <motion.div
        style={{ y: textY, opacity: textOpacity }}
        className="relative space-y-8 lg:space-y-10 z-10 flex-1"
      >
        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-primaryColor/20 to-secondaryColor/20 border border-primaryColor/30 rounded-full px-5 py-2.5 backdrop-blur-sm"
        >
          <div className="w-2 h-2 bg-primaryColor rounded-full animate-pulse"></div>
          <span className="text-sm font-semibold text-white/90 heading">
            Your Creative Journey Starts Here
          </span>
        </motion.div>

        {/* Main Heading */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight heading"
        >
          Take the Next Step <br className="hidden lg:block" />
          <span className="bg-gradient-to-r from-primaryColor via-white to-secondaryColor bg-clip-text text-transparent">
            Toward Your Creative
          </span>
          <br className="hidden lg:block" /> and Professional Dreams
        </motion.h1>

        {/* Decorative Line */}
        <motion.div
          initial={{ width: 0 }}
          whileInView={{ width: "80px" }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="h-1.5 bg-gradient-to-r from-primaryColor to-secondaryColor rounded-full"
        />

        {/* Description */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-white/80 text-base md:text-lg xl:text-xl leading-relaxed xl:w-[600px] sub-heading tracking-wide"
        >
          At{" "}
          <span className="font-bold text-red-500 heading">
            INSD – International School of Design
          </span>
          , we inspire students to transform imagination into innovation. From
          fashion to interior design, our collaborative courses, design
          exhibitions, and workshops help you grow into a confident,
          industry-ready creative professional.
        </motion.p>

        {/* Stats Cards */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex flex-wrap gap-4"
        >
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-5 py-3">
            <p className="text-3xl font-extrabold bg-gradient-to-r from-primaryColor to-secondaryColor bg-clip-text text-transparent heading">
              500+
            </p>
            <p className="text-sm text-white/60 sub-heading">Alumni Success</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-5 py-3">
            <p className="text-3xl font-extrabold bg-gradient-to-r from-primaryColor to-secondaryColor bg-clip-text text-transparent heading">
              50+
            </p>
            <p className="text-sm text-white/60 sub-heading">Expert Mentors</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-5 py-3">
            <p className="text-3xl font-extrabold bg-gradient-to-r from-primaryColor to-secondaryColor bg-clip-text text-transparent heading">
              100%
            </p>
            <p className="text-sm text-white/60 sub-heading">
              Placement Support
            </p>
          </div>
        </motion.div>

        {/* CTA Button */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
        >
          <button className="lg:hidden group relative bg-gradient-to-r from-primaryColor to-secondaryColor text-white font-bold rounded-2xl py-4 md:py-5 px-8 md:px-12 tracking-wider overflow-hidden transition-all duration-300 hover:scale-105 shadow-[0_10px_40px_rgba(218,51,53,0.4)] hover:shadow-[0_15px_50px_rgba(218,51,53,0.6)]">
            <span className="absolute inset-0 bg-gradient-to-r from-secondaryColor to-primaryColor opacity-0 group-hover:opacity-100 transition-opacity duration-500"></span>

            <span className="relative flex items-center gap-3 text-lg md:text-xl">
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                Explore Courses
              </span>
              <svg
                className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </span>
          </button>
        </motion.div> */}
      </motion.div>

      {/* Right Images Grid */}
      <motion.div
        style={{ scale: imageScale }}
        className="flex justify-center flex-1 z-10"
      >
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 md:gap-6 max-w-2xl">
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="group relative overflow-hidden rounded-2xl shadow-2xl hover:shadow-[0_20px_60px_rgba(218,51,53,0.4)] transition-all duration-500"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-primaryColor/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10"></div>
            <img
              src={grid_img_1}
              alt="INSD fashion workshop"
              className="lg:w-[400px] lg:h-[300px] w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 border-2 border-white/0 group-hover:border-white/30 rounded-2xl transition-all duration-500"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="group relative overflow-hidden rounded-2xl shadow-2xl hover:shadow-[0_20px_60px_rgba(20,73,130,0.4)] transition-all duration-500"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-secondaryColor/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10"></div>
            <img
              src={grid_img_3}
              alt="INSD interior design class"
              className="lg:w-[400px] lg:h-[300px] w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 border-2 border-white/0 group-hover:border-white/30 rounded-2xl transition-all duration-500"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="group relative overflow-hidden rounded-2xl shadow-2xl hover:shadow-[0_20px_60px_rgba(20,73,130,0.4)] transition-all duration-500"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-secondaryColor/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10"></div>
            <img
              src={grid_img_2}
              alt="INSD student exhibition"
              className=" lg:w-[400px] lg:h-[300px] w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 border-2 border-white/0 group-hover:border-white/30 rounded-2xl transition-all duration-500"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="group relative overflow-hidden rounded-2xl shadow-2xl hover:shadow-[0_20px_60px_rgba(218,51,53,0.4)] transition-all duration-500"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-primaryColor/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10"></div>
            <img
              src={grid_img_4}
              alt="INSD creative project"
              className=" lg:w-[400px] lg:h-[300px] w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 border-2 border-white/0 group-hover:border-white/30 rounded-2xl transition-all duration-500"></div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default EventsSection;
